























import BaseComponent from '@/components/base-component.vue';
import ArrayUtils from '@/helpers/arrayUtils';
import * as service from '@/services/teams';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import PermissionAuth from './permission-auth.vue';

@Component({
  components: {
    PermissionAuth
  }
})
export default class UiAutocompleTeams extends BaseComponent {
  @Prop()
  public value: any;

  @Prop({ default: 'Time' })
  public label?: string;

  @Prop({ default: 'Escolha o time' })
  public placeholder?: string;

  @Prop()
  public required?: boolean;

  @Prop()
  public disabled?: boolean;

  @Prop({ default: false })
  public showAddPatient?: boolean;

  @Prop({ default: () => [] })
  private rules?: any[];

  @Prop({ default: false })
  public multiple?: boolean;

  @Prop({ default: false })
  public chips?: boolean;

  @Prop({ default: false })
  public deletableChips?: boolean;

  @Prop({ default: true })
  public returnObject?: boolean;

  @Prop({ default: null })
  public clientUnitsIds?: number[];

  @Prop({ default: false })
  public immediate?: boolean;

  @Prop({ default: true })
  public showTeamsEmptyUnit?: boolean;

  public loading: boolean = false;

  public selected = null;
  public teams = [];

  mounted() {
    this.prepareSubjectBehaviorListTeams();
    this.loadTeams();
  }

  @Watch('value', {immediate: true})
  public onChangeValue(val) {
    this.selected = val;
  }

  @Watch('clientUnitsIds')
  public onClientUnitsIdsChange(clientUnitsIds, clientUnitsIdsOld) {
    if (ArrayUtils.equalsIgnoreOrder(clientUnitsIds, clientUnitsIdsOld)) {
      return;
    }
    this.loadTeams();
  }

  public onChange(val) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(false);

  prepareSubjectBehaviorListTeams() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return !val;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return service.listTeamsCombo(this.clientUnitsIds);
        })
      )
      .subscribe(
        (result) => {
          this.teams = result;
          if (this.selected && this.selected.length) {
            this.selected = this.selected.filter(s => this.teams.findIndex(t => t.id == s || t.id == s.id)>=0);
            this.onChange(this.selected);
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.showToastApiError(error);
        }
      );
  }

  loadTeams() {
    if (!this.showTeamsEmptyUnit && (!this.clientUnitsIds || !this.clientUnitsIds.length)) {
      this.teams = [];
      this.selected = [];
      this.onChange(this.selected);
      return;
    }
    this.execBehaviorSub$.next(true);
  }

  getItemText(item) {
    return `${item.unidade} -  ${item.nome}`;
  }
}
